import React, { useState, useEffect } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import './GenerateReports.css';

const GenerateReports = () => {
  const [reportType, setReportType] = useState('');
  const [term, setTerm] = useState('');
  const [session, setSession] = useState('');
  const [classGrade, setClassGrade] = useState('');
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!reportType) return;

    setLoading(true);
    const db = getDatabase();
    const path = reportType.toLowerCase() + "s"; // e.g., students, teachers, classes, fees
    const dataRef = ref(db, path);

    const unsubscribe = onValue(dataRef, (snapshot) => {
      let data = [];
      if (snapshot.exists()) {
        data = Object.values(snapshot.val());

        // Apply filters
        if (term) data = data.filter(item => item.term === term);
        if (session) data = data.filter(item => item.session === session);
        if (classGrade) data = data.filter(item => item.class === classGrade);
      }

      setReportData(data);
      setLoading(false);
    });

    return () => unsubscribe(); // Cleanup listener
  }, [reportType, term, session, classGrade]);

  const handleDownloadExcel = () => {
    alert("Excel download coming soon!");
    // Use SheetJS/xlsx library
  };

  const handleDownloadPDF = () => {
    alert("PDF download coming soon!");
    // Use jsPDF library
  };

  return (
    <div className="generate-reports">
      <h2>Generate School Reports</h2>

      <div className="report-filters">
        <label>Report Type:</label>
        <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
          <option value="">Select Report Type</option>
          <option value="Student">Student Report</option>
          <option value="Teacher">Teacher Report</option>
          <option value="Class">Class Report</option>
          <option value="Fee">Fee Report</option>
        </select>

        <label>Term:</label>
        <select value={term} onChange={(e) => setTerm(e.target.value)}>
          <option value="">Select Term</option>
          <option value="First">First Term</option>
          <option value="Second">Second Term</option>
          <option value="Third">Third Term</option>
        </select>

        <label>Session:</label>
        <input
          type="text"
          placeholder="e.g. 2024/2025"
          value={session}
          onChange={(e) => setSession(e.target.value)}
        />

        <label>Class/Grade:</label>
        <input
          type="text"
          placeholder="e.g. Primary 5"
          value={classGrade}
          onChange={(e) => setClassGrade(e.target.value)}
        />
      </div>

      {loading && <p>Loading data...</p>}

      {reportData.length > 0 && (
        <div className="report-preview">
          <h3>Report Preview</h3>
          <table>
            <thead>
              <tr>
                {Object.keys(reportData[0]).map((key) => (
                  <th key={key}>{key.toUpperCase()}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reportData.map((item, index) => (
                <tr key={index}>
                  {Object.values(item).map((val, idx) => (
                    <td key={idx}>{val}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          <div className="report-actions">
            <button onClick={handleDownloadPDF}>Download PDF</button>
            <button onClick={handleDownloadExcel}>Download Excel</button>
          </div>
        </div>
      )}

      {!loading && reportData.length === 0 && reportType && <p>No data found for the selected filters.</p>}
    </div>
  );
};

export default GenerateReports;